import styled from 'styled-components';

const EinCheckoutStyles = styled.section`
  padding-top: 0;
  width: 100%;

  ${props => props.theme.media.md} {
    max-width: 720px;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }

  ${props => props.theme.media.lg} {
    max-width: 960px;
  }

  ${props => props.theme.media.xl} {
    max-width: 1140px;
  }

  .content-wrapper {
    display: grid;
    grid-template-columns: 1fr;

    ${props => props.theme.media.lg} {
      grid-template-columns: 4fr 3fr;
      gap: 1rem;
    }

    ${props => props.theme.media.xl} {
      gap: 3rem;
    }

    .payment-form-container {
      order: 2;
      padding-top: 1rem;
      margin: 1rem auto 0;

      ${props => props.theme.media.lg} {
        margin-right: 1rem;
        order: 1;
      }

      .form-title {
        font-weight: 500;
        margin-bottom: 0;
        text-align: center;

        ${props => props.theme.media.lg} {
          font-size: 2rem;
        }
      }

      .form-subtitle {
        line-height: 1.4rem;
        margin: 0 auto 2rem;
        text-align: center;
        width: 85%;

        ${props => props.theme.media.md} {
          width: 75%;
        }
      }

      .inputs-wrapper {
        margin-bottom: 1rem;

        .section-title {
          margin-bottom: 0;
        }
      }
    }

    .submit-wrapper {
      margin-top: 2rem;

      button[type='submit'] {
        align-items: center;
        display: flex;
        justify-content: center;
        margin: 0 auto;
        max-width: 420px;

        svg {
          margin: 0 1rem;
        }
      }

      .cc-wrapper {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 1rem;
        justify-content: space-between;
        margin-top: 2rem;
        padding: 0 4rem;
      }

      .small {
        font-size: 0.83rem !important;

        & span {
          font-size: 0.83rem !important;
        }
      }
    }

    .ssl-wrapper {
      align-items: center;
      display: flex;
      margin-top: 2rem;
      padding: 0 2rem;
      text-align: center;

      span {
        color: ${props => props.theme.gray600};
        font-size: 0.875rem;
      }
    }

    .email-disclaimer {
      color: ${props => props.theme.gray600};
      font-size: 0.75rem;
      line-height: 1rem;
      margin: 0.5rem auto 0;
      width: 80%;
    }

    .payment-details-container {
      align-self: flex-start;
      margin-left: 0;
      order: 1;
      padding: 1rem;
      top: 52px;
      width: 100%;

      .bg-wrapper {
        background-color: #e4fcf8;
        padding: 1rem;
      }

      .email-disclaimer {
        color: ${props => props.theme.gray600};
        font-size: 0.75rem;
        line-height: 1rem;
        margin: 0.5rem auto 0;
        width: 80%;
      }

      ${props => props.theme.media.lg} {
        position: relative;
        margin-left: 1rem;
        margin-top: 2rem;
        order: 2;
        padding: 1rem 1rem 2rem;
        top: 0;
      }

      .details-title {
        color: #2c8978;
        margin-bottom: 0;
        text-align: center;
      }

      .price {
        color: ${props => props.theme.textColor};
        font-size: 3rem;
        font-weight: 700;
        margin-bottom: 0;
        text-align: center;

        ${props => props.theme.media.md} {
          font-size: 4rem;
          margin-bottom: 1rem;
        }
      }

      .list-item-wrapper {
        padding: 0 2rem;

        .row {
          justify-content: space-between;

          p {
            margin-bottom: 0.5rem;

            ${props => props.theme.media.md} {
              margin-bottom: 1rem;
            }
          }

          .price-and-check {
            display: flex;

            svg {
              fill: #2c8978;
            }
          }

          &.select-row {
            display: grid;
            grid-template-columns: 1fr auto;
            grid-gap: 0.5rem;

            ${props => props.theme.media.md} {
              grid-gap: 5rem;
            }

            select {
              height: 2.5rem;
            }
          }
        }
      }

      .did-you-know {
        margin-top: 1rem;

        .d-flex {
          align-items: center;
          justify-content: center;
        }

        svg {
          path,
          circle {
            stroke: none;
          }
        }

        h3 {
          color: #2c8978;
          font-weight: 500;
          margin-bottom: 0;
          margin-left: 0.5rem;
          text-align: center;
        }

        p {
          font-size: 0.8rem;
          margin-bottom: 0;
          text-align: center;

          ${props => props.theme.media.md} {
            font-size: 1rem;
            margin-bottom: 1rem;
          }
        }
      }
    }
  }
`;

export default EinCheckoutStyles;
